<template>
  <div id="app">
    <div class="box">
      <div class="floating-element"></div>
      <!-- 浮动元素 -->
      <nav id="nav" class="navbar-box"  :class="{ 'fix-nav': navBarFixed }">
        <!-- 导航栏内容 -->
        <Header></Header>
      </nav>
      <router-view />
      <Footer></Footer>
      <GoTop></GoTop>
      <customer></customer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navBarFixed: false,
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  },

  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },

  methods: {
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 容器的高度
      var offsetTop = document.querySelector("#nav").offsetHeight;

      console.log("scrollTop=>", scrollTop, "  offsetTop=>", offsetTop);

      //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if (scrollTop > offsetTop) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }

    },
  },
};
</script>

<style scoped lang="less">
#app {
  font-family: "PingFang SC-Medium, PingFang SC";
}
.floating-element {
  /* height: 200px; 浮动元素的高度 */
  // background-color: rgb(36, 38, 50); /* 浮动元素的背景颜色 */
}

/* 固定导航 */
.fix-nav {
  position: fixed;
  top: 0;
  z-index: 999;
}



.navbar-box {
  width: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index: 9999;
  // border-bottom: 0.05rem solid rgba(255, 255, 255, 0.1);

  // height: 60px;
  // position: sticky;
  // top: -1px;
  // z-index: 99999; /* 确保导航栏在浮动元素之上 */
  // border-left: 0;
  // border-right: 0;
  // /* border-top: 0px; */
  // /* 导航栏样式 */
}
</style>
